import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, Table, TableBody, TableCell, TableRow, Tooltip } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import { IconButton, Dialog, Button } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { docTypes } from '../../constants';
import { BoldTableHead } from 'components/common/TableStyles';
import FakeTextWrapper from 'components/common/FakeTextWrapper';

const FileHistoryComponent = ({ loading, files, docType, onDownloadFile, onCloseModal }) => {
  const { t } = useTranslation();

  const handleDownloadFile = useCallback(uniqueId => () => onDownloadFile(uniqueId), [onDownloadFile]);

  return (
    <Dialog
      id='file-history-dialog'
      open
      disableBackdropClick
      fullWidth
      maxWidth={'md'}
      onClose={onCloseModal}
      title={t('Offer.Edit.FileHistory.FileHistory')}
      content={
        <Grid container justifyContent={'center'}>
          {loading && <FakeTextWrapper />}
          {!loading && (
            <Table>
              <BoldTableHead>
                <TableRow>
                  {docType === docTypes.PRINT && <TableCell>{t('Offer.Edit.FileHistory.Version')}</TableCell>}
                  <TableCell>
                    {docType === docTypes.PRINT ? t('Offer.Edit.FileHistory.FileName') : t('Offer.Edit.FileHistory.OriginalFileName')}
                  </TableCell>
                  <TableCell>
                    {docType === docTypes.PRINT ? t('Offer.Edit.FileHistory.ExportDate') : t('Offer.Edit.FileHistory.UploadDate')}
                  </TableCell>
                  <TableCell>
                    {docType === docTypes.PRINT ? t('Offer.Edit.FileHistory.ExportedBy') : t('Offer.Edit.FileHistory.UploadedBy')}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </BoldTableHead>
              <TableBody>
                {files &&
                  files.map((file, idx) => {
                    return (
                      <TableRow key={idx}>
                        {docType === docTypes.PRINT && <TableCell>{file.fileVersion}</TableCell>}
                        <TableCell>{file.originalFileName}</TableCell>
                        <TableCell>
                          {t('DATE_FORMAT', {
                            date: { value: file.uploadDate, format: 'DD.MM.YYYY HH:mm:ss' }
                          })}
                        </TableCell>
                        <TableCell>{file.userName}</TableCell>
                        <TableCell sx={{ width: '75px' }}>
                          <Tooltip title={t('Tooltips.Download')}>
                            <IconButton id={`file_Download_${idx}`} size={'small'} onClick={handleDownloadFile(file.uniqueId)}>
                              <CloudDownload />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          )}
        </Grid>
      }
      actions={
        <Button color={'primary'} onClick={onCloseModal}>
          {t('General.Close')}
        </Button>
      }
    />
  );
};

FileHistoryComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  files: PropTypes.array.isRequired,
  docType: PropTypes.string.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default FileHistoryComponent;
